(function () {
  var badgeSelector = '.jdgm-prev-badge, .jdgm-preview-badge, [data-open-reviews]';
  var widgetSelector = '#judgeme_product_reviews, .jdgm-review-widget, #shopify-product-reviews, [data-reviews-target]';

  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  function findTarget() {
    var widgets = document.querySelectorAll(widgetSelector);
    for (var i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      var tabContent = widget.closest('.tab-content');
      var tabs = tabContent ? tabContent.closest('tabs-component') : null;
      if (tabContent && tabs) {
        if (isVisible(tabs)) return { type: 'tab', widget: widget, tabs: tabs, tabContent: tabContent };
        continue;
      }
      var details = widget.closest('details[data-collapsible]');
      if (details) {
        if (isVisible(details)) return { type: 'collapsible', widget: widget, details: details };
        continue;
      }
      if (isVisible(widget)) return { type: 'plain', widget: widget };
    }
    return null;
  }

  function openTarget(target) {
    if (target.type === 'tab') {
      var match = target.tabContent.className.match(/tab-content-(\d+)/);
      var index = match ? match[1] : null;
      var link = index !== null ? target.tabs.querySelector('.tab-link[data-tab="' + index + '"]') : null;
      if (link && !link.classList.contains('current')) link.click();
    } else if (target.type === 'collapsible') {
      var wrapper = target.details.closest('collapsible-elements');
      if (wrapper && typeof wrapper.open === 'function') {
        wrapper.open(target.details);
      } else {
        target.details.setAttribute('open', 'true');
      }
    }
  }

  function scrollToTarget(target) {
    var el = target.type === 'tab' ? target.tabs : target.type === 'collapsible' ? target.details : target.widget;
    var header = document.querySelector('[data-header-height], .site-header, header.header');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset - 16;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  document.addEventListener(
    'click',
    function (event) {
      var badge = event.target.closest(badgeSelector);
      if (!badge || badge.closest('.product-item, .product-grid-item, [data-grid-item]')) return;

      var target = findTarget();
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      openTarget(target);
      setTimeout(function () {
        scrollToTarget(target);
      }, 80);
    },
    true
  );
})();
